const AutoWrapHeader = ({ text }) => (
  <span
    style={{
      whiteSpace: "normal",
      lineHeight: "1.2",
      textAlign: "start",
      display: "inline-block",
      width: "100%",
    }}
  >
    {text}
  </span>
);
export default  AutoWrapHeader;